module.exports = __webpack_public_path__ + "static/media/error_icon.2b09afd2.svg";